import actionTypes from "./actionTypes";

const initialState = {
  groups: [],
  categories: [],
  brands: [],
  suppliers: [],
  customers: [],
  currencies: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_BRAND_SUCCESS:
      return {
        ...state,
        brands: payload,
      };

    case actionTypes.GET_BRAND_FAILED:
      return {
        ...state,
        brands: [],
      };

    case actionTypes.GET_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: payload,
      };

    case actionTypes.GET_PRODUCT_CATEGORY_FAILED:
      return {
        ...state,
        categories: [],
      };

    case actionTypes.GET_PRODUCT_GROUP_SUCCESS:
      return {
        ...state,
        groups: payload,
      };

    case actionTypes.GET_PRODUCT_GROUP_FAILED:
      return {
        ...state,
        groups: [],
      };

    case actionTypes.GET_SUPPLIER_SUCCESS:
      return {
        ...state,
        suppliers: payload,
      };

    case actionTypes.GET_SUPPLIER_FAILED:
      return {
        ...state,
        suppliers: [],
      };

    case actionTypes.GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: payload,
      };

    case actionTypes.GET_CUSTOMERS_FAILED:
      return {
        ...state,
        customers: [],
      };

    case actionTypes.GET_CURRENCY_SUCCESS:
      return {
        ...state,
        currencies: payload,
      };

    case actionTypes.GET_CURRENCY_FAILED:
      return {
        ...state,
        currencies: [],
      };

    default:
      return state;
  }
};

export default reducer;
